import React, { useEffect } from 'react'
import CustomModal from '../../../../../components/CroreUIModal'
import { CCol, CFormInput, CFormLabel, CRow } from '@coreui/react'
import { useDispatch } from 'react-redux'
import { AddContactCategoryRequestAction, getContactCategoryRequestAction, resetContactPropsAction } from '../../../../../service/actions/contactActions'
import { useSelector } from 'react-redux'
import CustomValuesHook from '../../../../../Hooks/customValuesHook'

const AddContactCategory = ({ display = false, setDisplay }: { display: boolean, setDisplay: Function }) => {
    const pending = useSelector((state: any) => state.contactReducer.addContactCategoryPending)
    const success = useSelector((state: any) => state.contactReducer.addContactCategorySuccess)
    const [contactCategory, setContactCategory] = CustomValuesHook({
        name: '',
    })
    const dispatch = useDispatch()

    useEffect(() => {
        if (success) {
            setContactCategory({ name: '' })
            dispatch(getContactCategoryRequestAction({
                pageSize: 1000,
                pageNumber: 1,
                disablePaging: true,
                sortText: "",
                whereConditionText: ""
            }))
            dispatch(resetContactPropsAction())
            setDisplay(false)

        }
    }, [success])
    const handleAddPhonebook = (e: any) => {
        if (e) {
            e.preventDefault()
        }
        if (contactCategory.name) {
            dispatch(AddContactCategoryRequestAction(contactCategory.name))

        }
    }
    const bodyComponent = () => {
        return (<div>
            <form onSubmit={handleAddPhonebook}>
                <CRow>
                    <CCol lg={12} xs={12} className='p-4'>
                        <CFormLabel htmlFor="nameInput">نام
                            <span className="required"> * </span>
                        </CFormLabel>
                        <div className='position-relative'>
                            <CFormInput
                                value={contactCategory.name}
                                onChange={(e) => setContactCategory({ name: e.target.value })}
                                type="text"
                                id="nameInput"
                                required
                            />
                        </div>
                    </CCol>

                </CRow>
            </form>
        </div>)
    }

    const titleComponent = () => {
        return (<div style={{ fontSize: '14px' }}>اضافه کردن دسته‌بندی مخاطبین</div>)
    }
    const footerComponent = () => {

        return (<div className='d-flex justify-content-end'>
            <button className='btn btn-default mx-2' onClick={() => setDisplay(false)} >انصراف</button>
            <button className='btn btn-primary' disabled={!contactCategory.name || pending} onClick={handleAddPhonebook}>ثبت</button>
        </div>)
    }
    return (
        <CustomModal
            setShow={() => setDisplay(false)}
            title={titleComponent}
            component={bodyComponent}
            show={display}
            footerComponent={footerComponent}
            size={'sm'}
        />
    )
}

export default AddContactCategory